"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryExternalSourceDto = void 0;
class InventoryExternalSourceDto {
    constructor(params) {
        this.url = "";
        this.identifier = "";
        this.createdAt = "";
        this.updatedAt = "";
        this.sourceType = "";
        this.ftpServer = "";
        this.ftpUser = "";
        this.ftpPass = "";
        this.remotePath = "";
        this.excludedFiles = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.inventoryProviderId = params.inventoryProviderId;
        this.url = params.url;
        this.identifier = params.identifier;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        this.sourceType = params.sourceType;
        this.ftpServer = params.ftpServer;
        this.ftpUser = params.ftpUser;
        this.ftpPass = params.ftpPass;
        this.remotePath = params.remotePath;
        this.excludedFiles = params.excludedFiles;
    }
}
exports.InventoryExternalSourceDto = InventoryExternalSourceDto;
//# sourceMappingURL=InventoryExternalSourceDto.js.map